/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createUnitCostLog } from '../fn/unit-cost-logs/create-unit-cost-log';
import { CreateUnitCostLog$Params } from '../fn/unit-cost-logs/create-unit-cost-log';
import { deleteUnitCostLog } from '../fn/unit-cost-logs/delete-unit-cost-log';
import { DeleteUnitCostLog$Params } from '../fn/unit-cost-logs/delete-unit-cost-log';
import { getUnitCostLog } from '../fn/unit-cost-logs/get-unit-cost-log';
import { GetUnitCostLog$Params } from '../fn/unit-cost-logs/get-unit-cost-log';
import { listUnitCostLogs } from '../fn/unit-cost-logs/list-unit-cost-logs';
import { ListUnitCostLogs$Params } from '../fn/unit-cost-logs/list-unit-cost-logs';
import { UnitCostLogDto } from '../models/unit-cost-log-dto';
import { UnitCostLogDtoPage } from '../models/unit-cost-log-dto-page';
import { updateUnitCostLog } from '../fn/unit-cost-logs/update-unit-cost-log';
import { UpdateUnitCostLog$Params } from '../fn/unit-cost-logs/update-unit-cost-log';

@Injectable({ providedIn: 'root' })
export class UnitCostLogsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listUnitCostLogs()` */
  static readonly ListUnitCostLogsPath = '/v0/unitCostLogs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUnitCostLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitCostLogs$Response(params?: ListUnitCostLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostLogDtoPage>> {
    return listUnitCostLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUnitCostLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitCostLogs(params?: ListUnitCostLogs$Params, context?: HttpContext): Observable<UnitCostLogDtoPage> {
    return this.listUnitCostLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitCostLogDtoPage>): UnitCostLogDtoPage => r.body)
    );
  }

  /** Path part for operation `getUnitCostLog()` */
  static readonly GetUnitCostLogPath = '/v0/unitCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnitCostLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitCostLog$Response(params: GetUnitCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostLogDto>> {
    return getUnitCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnitCostLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitCostLog(params: GetUnitCostLog$Params, context?: HttpContext): Observable<UnitCostLogDto> {
    return this.getUnitCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitCostLogDto>): UnitCostLogDto => r.body)
    );
  }

  /** Path part for operation `updateUnitCostLog()` */
  static readonly UpdateUnitCostLogPath = '/v0/unitCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUnitCostLog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnitCostLog$Response(params: UpdateUnitCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUnitCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUnitCostLog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnitCostLog(params: UpdateUnitCostLog$Params, context?: HttpContext): Observable<void> {
    return this.updateUnitCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createUnitCostLog()` */
  static readonly CreateUnitCostLogPath = '/v0/unitCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUnitCostLog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnitCostLog$Response(params: CreateUnitCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostLogDto>> {
    return createUnitCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUnitCostLog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnitCostLog(params: CreateUnitCostLog$Params, context?: HttpContext): Observable<UnitCostLogDto> {
    return this.createUnitCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitCostLogDto>): UnitCostLogDto => r.body)
    );
  }

  /** Path part for operation `deleteUnitCostLog()` */
  static readonly DeleteUnitCostLogPath = '/v0/unitCostLogs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUnitCostLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUnitCostLog$Response(params: DeleteUnitCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUnitCostLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUnitCostLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUnitCostLog(params: DeleteUnitCostLog$Params, context?: HttpContext): Observable<void> {
    return this.deleteUnitCostLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
